/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'traffic-logs-graph';
const prefix = `${moduleName}.${componentName}`;

export const significantLabel = `${prefix}.significantLabel`;
export const nonSignificantLabel = `${prefix}.nonSignificantLabel`;
export const userDefinedLabel = `${prefix}.userDefinedLabel`;
export const missingLabel = `${prefix}.missingLabel`;
export const missingDescription = `${prefix}.missingDescription`;

export const ENGLISH = {
    [significantLabel]: 'Significant',
    [nonSignificantLabel]: 'Non-significant',
    [userDefinedLabel]: 'User Defined',
    [missingLabel]: 'Missing Logs',
    [missingDescription]: 'This could be due to purging or rate limiting logs.',
};
